<template>
  <el-row :gutter="30" class="articles-container">
      <el-col :span="8">
         <el-card :body-style="{ padding: '0px' }">
          <div class="image-box" style='background-image: url("http://en.es-static.us/upl/2013/04/organic-food.jpg");'>
            
          </div>
          <div style="padding: 14px;">
            <span class="article-title">What is perimiter Shoping?</span>
            <p class="article-description">Find out how to sustain a good workout routine for life.</p>
            <div class="bottom clearfix">
              <el-button type="primary" @click="goToArticle" class="button">Read More</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
         <el-card :body-style="{ padding: '0px' }">
          <div class="image-box" style='background-image: url("https://greatist.com/sites/default/files/Chicken%20Meal%20Prep.jpg");'>
            
          </div>
          <div style="padding: 14px;">
            <span class="article-title">Meal Prep 101</span>
            <p class="article-description">Find out how to sustain a good workout routine for life.</p>
            <div class="bottom clearfix">
              <el-button type="primary" @click="goToArticle" class="button">Read More</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
      	<el-card :body-style="{ padding: '0px' }">
          <div class="image-box" style='background-image: url("https://williamshealthgroup.files.wordpress.com/2012/03/province-rob-sofa-pushup.jpg");'>
            
          </div>
          <div style="padding: 14px;">
            <span class="article-title">No gym, no problem</span>
            <p class="article-description">Find out how to sustain a good workout routine for life.</p>
            <div class="bottom clearfix">
              <el-button type="primary" @click="goToArticle" class="button">Read More</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
</template>

<script>
export default {
  name: 'articles',
  data () {
    return {
      savingData: false
    }
  },
  methods:{
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    goToArticle:function(){
    	this.$router.push('/dashboard/content/article');
    }
  }
}
</script>

<style>
  .articles-container .image-box {
    width: 100%;
    height: 100px;
    background-size: cover;
  }

  .articles-container .el-card span.article-title{
    font-weight: bold;
    margin: 0;
    text-align: left;
    color: #666;
    width: 100%;
    display: block;
    margin-bottom: 5px;
  }
  .articles-container .el-card p.article-description{
    margin: 0 0 15px;
    font-size: 14px;
    text-align: left;
    color: #666;
  }
  .el-card {
  	border-radius: 0;
  	border:0;
  }
</style>
